"use client";

/**
 * Fires a one-time industry landing page view event (with UTM params when present).
 * Dedicated ad landing URLs use UTMs like:
 * /industry/highschool?utm_source=google&utm_medium=cpc&utm_campaign=hs_spiritwear
 * GA also captures UTMs automatically; this event makes vertical + campaign easy to report.
 */
import { useEffect } from "react";
import { useSearchParams } from "next/navigation";
import { trackIndustryLandingView } from "@/lib/analytics";

type IndustryLandingAnalyticsProps = {
  vertical: string;
};

export function IndustryLandingAnalytics({
  vertical,
}: IndustryLandingAnalyticsProps) {
  const searchParams = useSearchParams();

  useEffect(() => {
    trackIndustryLandingView({
      vertical,
      utmSource: searchParams.get("utm_source") ?? undefined,
      utmMedium: searchParams.get("utm_medium") ?? undefined,
      utmCampaign: searchParams.get("utm_campaign") ?? undefined,
    });
    // Fire once per mount for this vertical (searchParams identity is stable enough here).
    // eslint-disable-next-line react-hooks/exhaustive-deps -- intentional one-shot on mount
  }, [vertical]);

  return null;
}
